<template>
  <el-form
    ref="account"
    :model="account"
    :rules="rules"
    status-icon
    autocomplete="on"
    label-position="left"
  >
    <el-form-item prop="phone">
      <el-input
        type="text"
        v-model="account.phone"
        placeholder="请输入手机号码"
        tabindex="1"
        autocomplete="on"
      >
        <template slot="prepend">
          <svg-icon icon-class="mobile" class="phone-icon" />
        </template>
      </el-input>
    </el-form-item>

    <el-form-item prop="code">
      <el-input v-model="account.code" style="width:300px;" />
      <verification-code
        :deviceID="account.phone"
        :phoneNum="account.phone"
        businessType="register"
        style="float:right;"
      />
    </el-form-item>

    <el-form-item>
      <el-checkbox v-model="isAgree">
        我已阅读并同意
        <el-link
          :underline="false"
          target="_blank"
          href="https://www.gobills.cn/agreement"
          type="primary"
        >《Gobills用户协议》</el-link>
      </el-checkbox>
    </el-form-item>

    <el-form-item>
      <el-button type="primary" @click="verifyAccount" :disabled="!isAgree" class="next-button">下一步</el-button>
    </el-form-item>
  </el-form>
</template>
<script>
import VerificationCode from "@/components/code/code";
import { phoneNumber, verificationCode } from "@/validator/validator";

export default {
  components: {
    VerificationCode
  },
  data() {
    return {
      isAgree: "",
      account: {
        phone: "",
        code: ""
      },
      rules: {
        phone: phoneNumber,
        code: verificationCode
      }
    };
  },
  methods: {
    verifyAccount() {
      this.$refs.account.validate(valid => {
        if (!valid) return false;
        this.confrimAccount();
      });
    },

    async confrimAccount() {
      const data = {
        code: this.account.code,
        phoneNum: this.account.phone,
        deviceID: this.account.phone,
        type: "mobile"
      };

      await this.$api.checkCode(data);

      this.$Message.success("账户创建成功！");

      this.$parent.phoneNum = this.account.phone;

      this.$parent.currentStep = 1;
    }
  }
};
</script>
<style scoped>
.next-button {
  width: 100%;
  margin-top: 25px;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 4px;
}
</style>

